import React from "react";
import FullPageLoader from "../../FullPageLoader/components";
import * as localStorage from "../../../../lib/localStorage";

/**
 * The theme components only imports it's theme CSS-file. These components are lazy
 * loaded, to enable "code splitting" (in order to avoid the themes being bundled together)
 */
const LightTheme = React.lazy(() => import("./LightTheme"));
const DarkTheme = React.lazy(() => import("./DarkTheme"));

const isDarkTheme = localStorage.getItem("theme") === "dark";

function ThemeSelector({ children }) {
    return (
        <>
            {/* Conditionally render theme, based on the current client context */}
            <React.Suspense fallback={<FullPageLoader fullPage />}>
                {isDarkTheme && <DarkTheme />}
                {!isDarkTheme && <LightTheme />}
            </React.Suspense>
            {/* Render children immediately! */}
            {children}
        </>
    );
}

export default ThemeSelector;
